import { parseNotionDate } from './parseNotionDate';

type NotionRangeDate =
  | string
  | {
      start?: string | null;
      end?: string | null;
    }
  | null
  | undefined;

export type NotionDateRangeStatus = {
  label: string;
  tone: 'neutral' | 'warning' | 'danger';
  startDate: Date | null;
  endDate: Date | null;
  isRange: boolean;
  daysLate: number;
};

export function getNotionDateRangeStatus(
  notionDate: NotionRangeDate,
): NotionDateRangeStatus | null {
  if (!notionDate) return null;

  const startDate = parseNotionDate(notionDate);
  if (!startDate) return null;

  const endDate =
    typeof notionDate === 'object' && notionDate?.end
      ? parseNotionDate(notionDate.end)
      : null;

  const referenceEndDate = endDate ?? startDate;
  const normalizedToday = new Date();
  normalizedToday.setHours(0, 0, 0, 0);

  const normalizedStart = new Date(startDate);
  normalizedStart.setHours(0, 0, 0, 0);

  const normalizedEnd = new Date(referenceEndDate);
  normalizedEnd.setHours(0, 0, 0, 0);

  // Enquanto estiver no intervalo (start..end), considerar em execução.
  if (normalizedToday >= normalizedStart && normalizedToday <= normalizedEnd) {
    return {
      label: 'Em execução hoje',
      tone: 'warning',
      startDate,
      endDate,
      isRange: !!endDate,
      daysLate: 0,
    };
  }

  if (normalizedToday > normalizedEnd) {
    const daysLate = Math.floor(
      (normalizedToday.getTime() - normalizedEnd.getTime()) / (1000 * 60 * 60 * 24),
    );
    return {
      label: `${daysLate} dia${daysLate !== 1 ? 's' : ''} atrasado`,
      tone: 'danger',
      startDate,
      endDate,
      isRange: !!endDate,
      daysLate,
    };
  }

  return {
    label: 'Programada',
    tone: 'neutral',
    startDate,
    endDate,
    isRange: !!endDate,
    daysLate: 0,
  };
}
